module.exports = __webpack_public_path__ + "img/waste_disposal.7cb0aa66.svg";